import { useEffect } from "react";
import useTrackEvent from "../hooks/useTrackEvent";
import { ReactComponent as IllusTop } from "../img/illustrations/begin_top.svg";
import { ReactComponent as IllusBottom } from "../img/illustrations/begin_bottom.svg";
import Button from "../components/Button";
import { useSwiper } from "swiper/react";

const BeginStep = ({ initialProps, step }) => {
  const swiper = useSwiper();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent('simu_start');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="content begin">
      <IllusTop className="main-illus top"/>
      <h3>Évaluez votre projet solaire</h3>
      <h3 className="bgred">en 30 secondes</h3>
      <div className="middle">
        Sans blabla. Sans formulaire.<br/>Juste une première idée pour voir si le solaire peut vous faire économiser.
      </div>
      <Button variant='yellow' onclick={() => swiper.slideNext()}>Commencez</Button>
      <IllusBottom className="main-illus bottom"/>
      <div className="footer">
        <div className="entry">Estimation gratuite</div>
        <div className="entry">Aucune coordonnée demandée</div>
        <div className="entry">Zéro engagement</div>
      </div>
    </div>
  )
}

export default BeginStep;